module.exports = __webpack_public_path__ + "img/share_dev_bg.7f0369d7.jpg";